import { render, staticRenderFns } from "./EmptyRoute.vue?vue&type=template&id=784d5cb0"
import script from "./EmptyRoute.vue?vue&type=script&lang=js"
export * from "./EmptyRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports